import React from 'react';
import { getTrans } from '@/utils/tools';
import { HISTORY_TRANSIFY_KEY } from '@/utils/constants';
import './style.scss';

interface UserCloseSessionProps {
  content?: string;
}

export default class UserCloseSession extends React.Component<UserCloseSessionProps> {
  render() {
    const { content } = this.props;
    return (
      <div className="close-session">{content || getTrans(HISTORY_TRANSIFY_KEY.USER_CLOSE_SESSION)}</div>
    );
  }
}
